import { render } from "./ContactView.vue?vue&type=template&id=92353440&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=92353440&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92353440"]])

export default __exports__